import {BaseLinkParams} from "../../../../../infrastructure/models/link/base-link-params";

  export class CompetitionMatchesPageLinkParams extends BaseLinkParams  {
  id: Number;
  competitorName: String;
  sportName: String;
  key: String;

  constructor(id: Number, sportName: String, competitorName: String, page: String) {
    super();

    this.id = id;
    this.sportName = sportName;
    this.competitorName = competitorName;
    this.key = `${competitorName}-${id}`;
    this.page = page;
  }
}